import { isNotProduction } from '@/components/shared/environment'

export const SANDBOX_ADA_ENV = 'tangocard-aip'
export const PROD_ADA_ENV = 'tangocard-gr'
export const DATA_HANDLE = isNotProduction() ? SANDBOX_ADA_ENV : PROD_ADA_ENV
export const SCRIPT_TYPE = 'text/javascript'
export const SCRIPT_ID = '__ada'
export const SCRIPT_SRC = 'https://static.ada.support/embed2.js'
